import React,{useEffect} from 'react';
import {toast } from 'react-toastify';
import Provider from "flexbiz-core/components/auth/Provider";
import {EmitEvents} from "flexbiz-core/utils";
import CartProvider  from "./CartProvider";


class MainProvider extends Provider{
    registerSocketEvents(socket,user){
      let _this = this;
      socket.on('blockchain.wallet.changed', function(data) {
        let wallet = data.receiver || data.sender;
        EmitEvents.dispatch('account.changed:' + wallet,wallet)
        EmitEvents.dispatch('account.changed',wallet)
        /*toast.info(`${_this.state.apis.getLabel("Số dư trong ví của bạn đã được cập nhật")}`,{hideProgressBar:true,autoClose: 3000,onClick:()=>{
          _this.profile(null,{tab:2});
        }})*/
      });
      socket.on('tx.hash', function(data) {
        EmitEvents.dispatch('tx.completed',data.txhash)
        EmitEvents.dispatch('tx.completed:' + data.txhash,data)
      });
      socket.on('message.action', function(data) {
        if(!data.logs[0].success) return;
        //
        data.action.forEach(async action=>{
          EmitEvents.dispatch('message.action:' + action,data)
        })
      });
      socket.on(`${user.email}.send`, function(msg) {
        console.log(msg);
        if(msg.logs.length===1){
          if(msg.logs[0].success){
            toast.success(_this.state.apis.getLabel("Giao dịch của bạn đã được thực hiện xong"),{hideProgressBar:true,autoClose: 1000})
          }else{
            let error = msg.logs[0].log.message;
            toast.error(error,{hideProgressBar:true,autoClose: 2000})
          }
        }
      });
      socket.on(`${user.email}.receive`, function(msg) {
        console.log(msg);
      });
    }
}

const MyProvider = (props)=>{
  const {children,...rest}= props;
  useEffect(() => {
    // Xóa màn hình chờ khỏi DOM
    const splashScreen = document.getElementById('loading-splash');
    if (splashScreen) {
        setTimeout(() => {
          splashScreen.classList.add('fade-out');
          splashScreen.remove();
          //Set background cho body
          document.body.style.backgroundColor = rest.config?.primaryColor
        },700);
    }
  },[])
  
  return (
    <MainProvider {...rest}>
      <CartProvider>
        {children}
      </CartProvider>
    </MainProvider>
  )
}
export default MyProvider;